import { kibanaServiceLog } from './logger';

const kibanaServiceLogWrapper = (data) => {
  const transformedData = { ...data };

  if (
    transformedData
    && transformedData.error
    && transformedData.error.data
    && typeof transformedData.error.data.status === 'string'
  ) {
    delete transformedData.error.data.status;
  }

  return kibanaServiceLog(transformedData);
};

export default kibanaServiceLogWrapper;
